import {
  Component,
  forwardRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidatorFn
} from '@angular/forms';
import {
  AgpFormUtil,
  CvaFormGroupComponent,
  ResetOptions
} from '@liberty-financial/agp-shared';

@Component({
  selector: 'spark-shared-phone-number',
  templateUrl: './phone-number.component.html',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SparkSharedPhoneNumberComponent),
      multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SparkSharedPhoneNumberComponent),
      multi: true
    }
  ]
})
export class SparkSharedPhoneNumberComponent
  extends CvaFormGroupComponent<string, string>
  implements OnChanges
{
  @Input() isRequired = false;
  @Input() label = 'Phone number';
  @Input() allowLeadingZeros: boolean = true;

  form = new FormControl(null as string | null, [
    this.phoneNumberValidator(
      RegExp('^(13\\d{4}|(1300|1800)\\d{6}|\\d{7,12})$')
    ) // e.g. 131234, 1300123456, 1800123456, 0312345678
  ]);
  formGroup = new FormGroup({
    phone: this.form
  });

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isRequired) {
      AgpFormUtil.Validators.updateRequiredIfNecessary(
        this.form,
        changes.isRequired.currentValue
      );
    }
  }

  protected reset(opts?: ResetOptions | undefined): void {
    this.form?.reset(undefined, opts);
  }

  /** lds-numeric-input can emit number; backend expects string. Coerce so NZ and AU both emit string. */
  protected transformToModel = (value: string | number | null): string =>
    value != null && value !== '' ? String(value) : '';

  constructor() {
    super();
  }

  private phoneNumberValidator(pattern: RegExp): ValidatorFn {
    return (control: AbstractControl): { [key: string]: string } | null => {
      const controlValue = control.value;

      if (!controlValue) {
        return null;
      }

      const isValid = pattern.test(controlValue);

      return isValid
        ? null
        : { phoneNumberValidator: 'Phone number is invalid' };
    };
  }
}
